import ServiceBase from '@/services/ServiceBase';

const resource = 'api/v1/property';

class PropertyService extends ServiceBase {
  constructor() {
    super({ resource });
  }
}

export default PropertyService;



// WEBPACK FOOTER //
// ./src/services/PropertyService.js